<template>
    <div class="mt-5">
        <form-modal
            title="Reject Narrative"
            v-model="isShowNarrativeReviewEditor"
            @submit="reviewNarrative"
            :loading="loading"
            submitButton="Reject">
            <fieldset>
                <div class="mb-3">
                    <label
                        for="reviewComment"
                        class="form-label"
                        >Comment</label
                    >

                    <textarea
                        type="text"
                        v-model="review.comment"
                        id="reviewComment"
                        class="form-control">
                    </textarea>
                </div>
            </fieldset>
        </form-modal>

        <form-modal
            title="Review Incident"
            v-model="isShowIncidentReviewEditor"
            @submit="reviewIncident"
            :loading="loading">
            <fieldset>
                <div class="mb-3">
                    <label
                        for="reviewStatus"
                        class="form-label"
                        >Status</label
                    >
                    <select
                        id="reviewStatus"
                        v-model="review.status"
                        class="form-select"
                        :class="{'is-invalid': !!errors.status}">
                        <option value="">Select Status</option>
                        <option value="IF">Reject Incident</option>
                        <option value="IP">Accept Incident</option>
                    </select>
                    <span
                        class="invalid-feedback"
                        role="alert"
                        v-if="errors.status">
                        {{ errors.status }}
                    </span>
                </div>
                <div class="mb-3">
                    <label
                        for="reviewComment"
                        class="form-label"
                        >Comment</label
                    >

                    <textarea
                        type="text"
                        v-model="review.comment"
                        id="reviewComment"
                        class="form-control">
                    </textarea>
                </div>
            </fieldset>
        </form-modal>

        <form-modal
            :title="uploadNarrativeTitle"
            v-model="isShowUploadNarrative"
            @submit="uploadDocument"
            :loading="loading">
            <fieldset>
                <div class="mb-3 row">
                    <div class="col-md-3">
                        <label
                            for="uploadNarrative"
                            class="col-form-label"
                            >File:</label
                        >
                    </div>
                    <div class="col-md-8">
                        <b-file-input
                            v-model="uploadNarrativeRequest.file"
                            name="uploadNarrative"
                            :error="errors.file"></b-file-input>
                    </div>
                </div>
            </fieldset>
        </form-modal>

        <template v-if="runAudits">
            <audit-jobs
                :run-audits="runAudits"
                :create-audits="createAudits"
                :audit="audit"
                :id="id"></audit-jobs>
        </template>

        <h2>Incidents</h2>

        <b-grid
            caption="List of Incidents"
            :tableOptions="auditIncidentStore.tableOptions"
            :filterableFields="auditIncidentStore.filterableFields"
            :filterOptions="auditIncidentStore.filterOptions"
            @optionChange="getData"
            :items="auditIncidentStore.items"
            :columns="columns"
            :loading="auditIncidentStore.loading">
            <template
                #beforeFilter
                v-if="canCheckIncidentsVersion">
                <button
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="checkIncidentsVersion()">
                    Update Incident Versions
                </button>
            </template>

            <template v-slot:cell.incidentNumber="{item, column}">
                <a href="#" @click.prevent="redirectToReportViewer(`MSIVReportViewer.aspx?IncidentNumber=${item.incidentNumber}&ORI=${item.ori}`)">{{ item.incidentNumber }}</a>
            </template>

            <template v-slot:cell.status="{item, column}">
                {{ item.statusName }}

                <i
                    class="bi bi-info-circle-fill text-info"
                    v-if="item.comment"
                    v-tooltip="item.comment"></i>

                <i
                    class="bi bi-info-circle-fill text-info"
                    v-else-if="item.narrative && item.narrative.comment"
                    v-tooltip="item.narrative.comment"></i>
                <template v-if="!item.loadId"> Deleted </template>
                <template v-else-if="item.actionLoadId && item.loadId != item.actionLoadId"> Updated </template>
            </template>
            <template v-slot:cell.actions="{item, column}">
                <span v-if="item.narrative == null">
                    <button
                        class="btn btn-primary btn-sm"
                        v-if="isAuditEditable && item.status == 'NR' && !runAudits"
                        @click.prevent="showUploadNarrative(item)">
                        Upload Narrative
                    </button>
                </span>
                <template v-else>
                    <a
                        v-if="item.narrative.hasFileContent"
                        class="btn btn-sm btn-secondary ms-1"
                        :href="`api/v1/audit/file/${item.narrative.fileId}`"
                        >View Narrative</a
                    >

                    <button
                        class="btn btn-primary btn-sm ms-1"
                        v-if="isAuditEditable && item.narrative.status != 'DA' && !runAudits"
                        @click.prevent="showUploadNarrative(item)">
                        Replace Narrative
                    </button>
                </template>
                <template v-if="runAudits && item.narrative">
                    <button
                        class="btn btn-danger btn-sm ms-1"
                        v-if="isAuditEditable && item.narrative.status == 'DU' && item.status == 'IN'"
                        @click.prevent="showNarrativeReviewEditor(item.id)">
                        Reject Narrative
                    </button>

                    <button
                        class="btn btn-primary btn-sm ms-1"
                        v-if="isAuditEditable && item.narrative.status == 'DU' && item.status == 'IN'"
                        @click.prevent="showIncidentReviewEditor(item.id)">
                        Review Incident
                    </button>

                    <button
                        class="btn btn-primary btn-sm ms-1"
                        v-if="isAuditEditable && (item.status == 'IF' || item.status == 'IP')"
                        @click.prevent="showIncidentReviewEditor(item.id)">
                        Update Review
                    </button>
                    <span v-else> </span>
                </template>
                <span v-else> </span>
                <button
                    class="btn btn-danger btn-sm ms-1"
                    v-if="runAudits && isAuditEditable"
                    @click.prevent="deleteIncident(item.id)">
                    Delete Request
                </button>
            </template>
        </b-grid>
    </div>
</template>
<script lang="ts" setup>
import {BTableColumn} from "../BTable/BTable.types";

import {FormModal} from "../Misc";
import AuditJobs from "./AuditJobs.vue";
import BGrid from "../BGrid/BGrid.vue";
import {onMounted, reactive, ref, computed} from "vue";
import {useAuditIncidentStore} from "@/stores/auditIncidentStore";
import {mixed, number, object, string} from "yup";
import {Audit, AuditReviewDocument, UploadNarrativeRequest} from "@/audit.types";
import {useFormValidation} from "@/validation";
import {debounce} from "vue-debounce";
import {BInput, BTextarea, BFileInput} from "../Fields";
import {storeToRefs} from "pinia";
import {useConfirmDialog} from "@/composable/useConfirmDialog";
const {confirm} = useConfirmDialog();

const props = defineProps<{
    id: number;
    audit: Audit;
    runAudits: boolean;
    createAudits: boolean;
}>();

var updateData = debounce(() => getData(), "15000ms");

const isShowUploadNarrative = ref(false);
const selectedIncindentId = ref(0);
const uploadNarrativeTitle = ref("");
const isConfirmDialog = ref(false);
const canCheckIncidentsVersion = ref(false);
const auditIncidentStore = useAuditIncidentStore();

const {loading} = storeToRefs(auditIncidentStore);

const uploadNarrativeRequest = ref({} as UploadNarrativeRequest);

const showUploadNarrative = (incident) => {
    isShowUploadNarrative.value = true;
    selectedIncindentId.value = incident.id;

    resetValidation();
    uploadNarrativeRequest.value = {} as UploadNarrativeRequest;
    uploadNarrativeRequest.value.id = incident.id;

    uploadNarrativeTitle.value = `Upload Narrative for incident ${incident.incidentNumber}`;
    return false;
};

const columns = reactive<BTableColumn[]>([
    {
        key: "incidentNumber",
        text: "Incident Number",
        sortable: true,
        value: (item) => item["incidentNumber"],
    },
    {
        key: "incidentType",
        text: "Type",
        sortable: true,
        value: (item) => item.type,
    },
    {
        key: "incidentDate",
        text: "Incident/Arrest Date",
        sortable: true,
        value: (item) => item["date"],
    },
    {
        key: "offenses",
        text: "Offense",
        sortable: false,
        value: (item) => item["offenses"],
    },
    {
        key: "status",
        text: "Status",
        sortable: false,
        value: (item) => item["statusName"],
    },
    {
        key: "actions",
        text: "",
        columnClass: ["text-end"],
        class: (item) => ["text-nowrap text-end"],
        sortable: false,
        value: (item) => 2,
    },
]);

const uploadNarrativeSchema = object<UploadNarrativeRequest>({
    id: number().required(),
    file: mixed().required().label("File"),
});

const {handleSubmit, errors, resetValidation} = useFormValidation();
const isShowNarrativeReviewEditor = ref(false);

const showNarrativeReviewEditor = (id: number) => {
    resetValidation();
    review.value = {status: ""} as AuditReviewDocument;
    selectedIncindentId.value = id;
    isShowNarrativeReviewEditor.value = true;
};

const isShowIncidentReviewEditor = ref(false);

const showIncidentReviewEditor = (id: number) => {
    resetValidation();
    selectedIncindentId.value = id;
    review.value = {status: ""} as AuditReviewDocument;
    isShowIncidentReviewEditor.value = true;
};

const reviewIncident = async function () {
    if (await handleSubmit(reviewIncidentSchema, review.value)) {
        review.value.id = selectedIncindentId.value;
        await auditIncidentStore.reviewIncident(review.value);
        isShowIncidentReviewEditor.value = false;
        await getData();
    }
};

const reviewNarrativeSchema = object<AuditReviewDocument>({});

const reviewIncidentSchema = object<AuditReviewDocument>({
    status: string().required().label("Status"),
});

const review = ref({} as AuditReviewDocument);

const reviewNarrative = async function () {
    if (await handleSubmit(reviewNarrativeSchema, review.value)) {
        review.value.id = selectedIncindentId.value;
        await auditIncidentStore.reviewNarrative(review.value);
        isShowNarrativeReviewEditor.value = false;
        await getData();
    }
};

const checkIncidentsVersion = async () => {
    await auditIncidentStore.checkIncidentsVersion(props.id);
    await getData();
};

const hideConfirmDialog = async function () {
    isConfirmDialog.value = false;
};
const deleteIncident = async function (id: number) {
    const shouldProceed = await confirm("Delete Confirmation", "Are You Sure?");
    if (shouldProceed) {
        await auditIncidentStore.deleteItem(id);
        await getData();
        await hideConfirmDialog();
    }
};

const getData = async () => {
    await auditIncidentStore.list(props.audit.id);
    await updateData();
};

const uploadDocument = async () => {
    if (await handleSubmit(uploadNarrativeSchema, uploadNarrativeRequest.value)) {
        await auditIncidentStore.uploadNarrative(uploadNarrativeRequest.value);
        await getData();
        isShowUploadNarrative.value = false;
    }
};

const isAuditEditable = computed(() => {
    return props.audit.statusCode != "AC";
});

const redirectToReportViewer = (url:string) => {
    //If we don't set the searchUrl value then NameSearch.aspx will be used
    sessionStorage.setItem("SearchURL", window.location.href.substring(window.location.href.lastIndexOf('/') + 1));
    window.open(url, '_blank');
}

onMounted(async () => {
    await getData();
});
</script>
